const discountCodeFn = () => {
  let discountCodeEles = document.querySelectorAll('div.discount-code-snippet .discount-code');
  discountCodeEles.forEach(btn => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();

        let current = e.currentTarget.parentNode.querySelector('.discount-success-msg');
        let curr = e.currentTarget.querySelector('span');
        let discount_code = e.currentTarget.dataset.id;
        let loaderclass = e.currentTarget.parentNode.querySelector('.codecopy-loader');

        loaderclass.style.display = 'block';
        current.style.display = 'none';

        fetch(`/discount/${discount_code}`, {method: 'GET'})
        .then(() => {
          loaderclass.style.display = 'none';
          current.style.display = 'block';
          current.innerHTML = window.offersSections.offers_text_after_apply;
          curr.classList.remove('before-apply');
          curr.classList.add('after-apply');
          discountCodeFn();
        })
        .catch(err => console.log(err))

    })
  });
} 
const offersCodeSlider = () => {
  // const sliderEle = document.querySelectorAll('.offer_slider');
  // sliderEle.forEach(slide => {
  //   new Swiper(slide, {
  //     loop: true, 
  //     speed:800,
  //     autoplay: {
  //       delay: 2500,
  //     },
  //     pagination: {
  //       el: ".swiper-pagination",
  //       clickable:true
  //     }
  //   });
  // })
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.codecopy-loader').forEach(svg => svg.style.display = "none")
  
  offersCodeSlider();
  discountCodeFn();
 
  
  const cartSummeryEle = document.querySelector('[data-subtotal]');
  if (cartSummeryEle) { 
    const updateOfferWidget = (data) => {
        let totalPrice = data.total_price / 100;
        let discountPricings = document.querySelectorAll('.discount-code-desc-inner');
        discountPricings.forEach(disEle => {
          let discountCodeEle = disEle.querySelector('.discount-code'); 
          let disPrice = parseInt(discountCodeEle.dataset.discountPrice);
          if(totalPrice >= disPrice) {
            discountCodeEle.classList.remove('disabled');
            disEle.querySelector('.discount-success-msg').classList.remove('error-animation');
            disEle.querySelector('.discount-success-msg').innerHTML = window.offersSections.offers_text_before_apply;
          } else {
            let getRemainAmmount = (disPrice - totalPrice) * 100;
            let remainAmmount = theme.Currency.formatMoney(getRemainAmmount, theme.settings.moneyFormat);
  
            discountCodeEle.classList.add('disabled');
            disEle.querySelector('.discount-success-msg').classList.add('error-animation');
            disEle.querySelector('.discount-success-msg').innerHTML = `To activate this offer Add <strong>${remainAmmount}</strong> more in your bucket.`;
          }
        })
        offersCodeSlider();
        discountCodeFn();
    }
    const cartUpdateMutation = new MutationObserver((entries) => {
      for (let i = 0; i < entries.length; i++) {
        const element = entries[i];
        console.log(element.type);
      }
      fetch('/cart.json',{method:'GET'}).then(res => res.json()).then(res => {
        updateOfferWidget(res);
      })

    });
    cartUpdateMutation.observe(cartSummeryEle, {childList:true,characterData: true})
  }
})
